import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 35px;
`;

export const SwitchContainer = styled.label`
    position: relative;
    display: inline-block;
    width: 40px;
    height: 13px;
`;

export const Slider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${props => (props.checked ? '#85E085' : '#FF9D9D')};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 25px;
    font-size: 14px;
    font-weight: bold;
    color: white;
    box-shadow: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
`;

export const Button = styled.span`
    position: absolute;
    top: 1px;
    background-color: ${props => (props.isNewValue ? '#4361EE' : props.checked ? '#3C3' : '#FF3939')};
    border-radius: 50%;
    width: 18px;
    height: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(${props => (props.checked ? '20px' : '0')}) translateY(-3.5px);
    color: #F6F6F6;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 8.743px;
    cursor: pointer;
    box-shadow: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    @media (min-width: 1281px) {
        top: 0;
        width: 20px;
        height: 20px;
        font-size: 15px;
    }
    
`;

export const Input = styled.input`
    display: none;
`;